import BaseApiService from './baseApi.service';

class ContactApiService extends BaseApiService {
    constructor(
        $cacheFactory,
        $http,
        $q,
        $rootScope,
        $state,
        $window,
        authService,
        toastService,
        queueService,
        eventEmitterService,
        envService
    ) {
        super(
            $cacheFactory,
            $http,
            $q,
            $rootScope,
            $state,
            $window,
            authService,
            toastService,
            queueService,
            eventEmitterService,
            envService,
            'contact'
        );
    }

    contactSupport(message) {
        return super.POST(`contact/support`, message);
    }

    contactSales(message) {
        return super.POST(`contact/sales`, message);
    }
}

ContactApiService.$inject = [
    '$cacheFactory',
    '$http',
    '$q',
    '$rootScope',
    '$state',
    '$window',
    'authService',
    'toastService',
    'queueService',
    'eventEmitterService',
    'envService'
];

export default ContactApiService;
